import type { NestedKeys } from '../../types.ts';

/**
 * `en` · `billing` namespace — credits, subscriptions, and the CCBill
 * checkout flow.
 */
export const billing = {
  title: 'Credits & subscription',
  balance: {
    credits: '{count} credits',
    tier: 'Current plan: {tier}',
  },
  plans: {
    title: 'Plans',
    subscribe: 'Subscribe',
    manage: 'Manage subscription',
    cancel: 'Cancel subscription',
  },
  packs: {
    title: 'Top-up packs',
    // `$` is copy; `{price}` is the pack's USD amount, already fixed to cents.
    // biome-ignore lint/suspicious/noTemplateCurlyInString: ICU-style i18n placeholder, not a JS template literal.
    price: '${price}',
  },
  purchase: {
    buyCredits: 'Buy credits',
    checkoutRedirect: 'Redirecting to secure checkout…',
    descriptorNote: 'Charges appear discreetly on your statement.',
  },
  status: {
    success: 'Payment successful. Credits added.',
    failed: 'Payment failed. Please try another method.',
    pending: 'Payment processing…',
  },
  subscriptionStatus: {
    active: 'Subscription active',
    past_due: 'Payment past due',
    canceled: 'Subscription canceled',
  },
  tiers: {
    free: 'Free',
    starter: 'Starter',
    plus: 'Plus',
    pro: 'Pro',
    max: 'Max',
  },
  statement: {
    title: 'Recent activity',
    empty: 'No activity yet.',
    credits: '{amount} credits',
  },
  ledgerReason: {
    subscription_grant: 'Subscription renewal',
    topup: 'Credit top-up',
    chat: 'Chat',
    image: 'Image generated',
    video: 'Video generated',
    referral_signup: 'Referral bonus',
    referral_revshare: 'Referral earnings',
    achievement: 'Achievement reward',
    refund: 'Refund',
    adjustment: 'Adjustment',
  },
  quota: {
    upsell: 'Upgrade to keep chatting and generating with no limits.',
  },
} as const;

export type BillingMessages = typeof billing;

/** Typo-safe dot-path keys for the `billing` namespace. */
export type BillingKey = NestedKeys<BillingMessages>;
